import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';

@inject("store")
@observer
export class DetalhamentoLocais extends Component {

    static propTypes = {
    };

    render() {
        const { solicitacao, lotacoes } = this.props.controller;
        const lotacaoId = _.get(solicitacao, "lotacaoId");
        const lotacao = lotacoes.filter(x => x.id === lotacaoId).map(v => v.nome).pop();

        return (
            <div>
                <h4>Locais</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Previsão trabalho externo</Label>
                            <Input type="text" value={_.get(solicitacao, "previsaoTrabalhoExterno") ? "Sim" : "Não"} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        {lotacao ?
                        <FormGroup>
                            <Label>Lotação </Label>
                            <Input type="text" value={lotacao} readOnly />
                        </FormGroup> :
                        <FormGroup>
                            <Label>Local de contratação </Label>
                            <Input type="text" value={_.get(solicitacao, "localContratacao.nome")} readOnly />
                        </FormGroup>}
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Local de trabalho </Label>
                            <Input type="text" value={_.get(solicitacao, "localTrabalho.template")} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}